import { render } from "./returngeneration.vue?vue&type=template&id=5eec9dba"
import script from "./returngeneration.vue?vue&type=script&lang=js"
export * from "./returngeneration.vue?vue&type=script&lang=js"

import "./returngeneration.vue?vue&type=style&index=0&id=5eec9dba&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__